import React, { useEffect, useState } from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  PDFDownloadLink,
  pdf,
  BlobProvider,
} from '@react-pdf/renderer'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { color } from '../../../api/ColorsSector'
import { Roboto } from '../../../fonts'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'
import { adress } from '../../../api/waterAdress'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'
import { useParams } from 'react-router-dom'
import {
  deleteData,
  updateData,
  getData,
  addPushData,
  upsertDataTournaments,
} from '../../../api/indexedDBHandler'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})
const colorsector = [
  '',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '7',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '#FF2C32',
  '13',
  '14',
  '15',
  '16',
  '17',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '26',
  '#FF2C32',
  '#FF2C32',
  '#FF2C32',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '#FF2C32',
]

const translations = {
  ru: [
    'Место проведения:',
    'Дата проведения:',
    'Дата составления:',
    'ПРОТОКОЛ ЖЕРЕБЬЁВКИ',
    'Ловля карпа - командные соревнования (мужчины, женщины), номер-код дисциплины 0920021811Л',
    'Ловля карпа – парные соревнования (мужчины, женщины), код дисциплины 0920151811Л',
    '#',
    'Команда',
    'Состав (Ф.И.О./разряд/год рождения)',
    '№ очереди',
    'Группа',
    'Сектор',
  ],
  en: [
    'Location:',
    'Date:',
    'Date of compilation:',
    'ROUND-ROBIN PROTOCOL',
    '',
    '',
    '#',
    'Nation',
    'Angler',
    'Queue number',
    'Zone',
    'Sector',
  ],
}
function getTranslation(index, lang) {
  return translations[lang]?.[index] || ''
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 25,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableTextBold: {
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})

const TournamentProtocolDrawPDF = ({
  allLogo,
  mainLogo,
  data,
  isBlank,
  administrator,
  tournament,
  date,
}) => {
  function formatDob(dob) {
    if (dob == '0000') return ''
    if (!dob) return '' // Проверяем на пустую строку, null, undefined
    const year = dob.split('-')[0] // Разбиваем строку по дефису и берем первый элемент (год)
    if (year == '0000') return ''
    return `, ${year} гр.` // Возвращаем год с добавлением " г."
  }

  const getname = (team, language) => {
    console.log('team', team)
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + formatDob(team[0]?.dob) + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + formatDob(team[1]?.dob) + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + formatDob(team[3]?.dob) + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''
    if (language == 'en') {
      return sp1 + sp2 + sp3
    }
    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }

  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 40,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        {/* Заголовок */}
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              {getTranslation(0, tournament.language)}{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.water_body} {adress(tournament.water_id)}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              {getTranslation(1, tournament.language)}{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              {getTranslation(2, tournament.language)}{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>
        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 1,
          }}
        >
          {getTranslation(3, tournament.language)}
        </Text>
        {tournament.competition_format != 'Парные соревнования' ? (
          <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 5 }}>
            {getTranslation(4, tournament.language)}
          </Text>
        ) : (
          <></>
        )}

        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 13 }}>
          {getTranslation(5, tournament.language)}
        </Text>

        <View
          style={{
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 0.3,
            borderColor: '#000',
          }}
        >
          <View
            style={{
              height: '20px',
              flexDirection: 'row',
              alignItems: 'stretch', // важно!
            }}
          >
            <View style={[styles.tableColHeader, { width: '6%' }]}>
              <Text style={styles.tableText}>
                {getTranslation(6, tournament.language)}
              </Text>
            </View>

            <View style={[styles.tableColHeader, { width: '27%' }]}>
              <Text style={styles.tableText}>
                {getTranslation(7, tournament.language)}
              </Text>
            </View>
            <View style={[styles.tableColHeader, { width: '40%' }]}>
              <Text style={styles.tableText}>
                {getTranslation(8, tournament.language)}
              </Text>
            </View>
            {tournament.competition_format != 'Парные соревнования' ? (
              <View style={[styles.tableColHeader, { width: '9%' }]}>
                <Text style={styles.tableText}>
                  {getTranslation(9, tournament.language)}
                </Text>
              </View>
            ) : (
              <View style={[styles.tableColHeader, { width: '13%' }]}>
                <Text style={styles.tableText}>
                  {getTranslation(9, tournament.language)}
                </Text>
              </View>
            )}
            {tournament.competition_format != 'Парные соревнования' ? (
              <View style={[styles.tableColHeader, { width: '9%' }]}>
                <Text style={styles.tableText}>
                  {getTranslation(10, tournament.language)}
                </Text>
              </View>
            ) : (
              <></>
            )}

            {tournament.competition_format != 'Парные соревнования' ? (
              <View style={[styles.tableColHeader, { width: '9%' }]}>
                <Text style={styles.tableText}>
                  {getTranslation(11, tournament.language)}
                </Text>
              </View>
            ) : (
              <View style={[styles.tableColHeader, { width: '14%' }]}>
                <Text style={styles.tableText}>
                  {getTranslation(11, tournament.language)}
                </Text>
              </View>
            )}

            {/* <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={[styles.tableColHeader, { width: '40%' }]}># </Text>
              <Text
                style={[
                  styles.tableColHeader,
                  { width: '27%', textAlign: 'left' },
                ]}
              >
                Команда (пара)
              </Text>
              <Text
                style={[
                  styles.tableColHeader,
                  { width: '40%', textAlign: 'left' },
                ]}
              >
                Состав (Ф.И.О./разряд)
              </Text>
              <Text style={[styles.tableColHeader, { width: '9%' }]}>
                Номер очереди
              </Text>
              {tournament.competition_format != 'Парные соревнования' ? (
                <Text style={[styles.tableColHeader, { width: '9%' }]}>
                  Группа
                </Text>
              ) : (
                <></>
              )}
              <Text style={[styles.tableColHeader, { width: '9%' }]}>
                Сектор
              </Text>
            </View> */}
          </View>
        </View>
        {data.map((item, index) => {
          if (item.team)
            return (
              <View key={index} wrap={false}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                    backgroundColor:
                      item.overallRank < 4
                        ? '#fff'
                        : item.totalWeight === 0
                          ? '#fff'
                          : '#fff',
                  }}
                >
                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '6%', fontWeight: 'bold' },
                    ]}
                  >
                    <Text style={styles.tableText}>{index + 1}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '27%' }]}>
                    <View style={{ alignSelf: 'flex-start' }}>
                      <Text style={styles.tableText}>
                        {item.team?.team_name_ru}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles.tableColHeader, { width: '40%' }]}>
                    <View style={{ alignSelf: 'flex-start', width: '100%' }}>
                      <Text style={[styles.tableText, { textAlign: 'left' }]}>
                        {getname(item.athlete, tournament.language)}
                      </Text>
                    </View>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      {
                        width:
                          tournament.competition_format != 'Парные соревнования'
                            ? '9%'
                            : '13%',
                      },
                    ]}
                  >
                    <Text style={styles.tableTextBold}>
                      {isBlank == false ? item.team?.queue : ''}
                    </Text>
                  </View>

                  {tournament.competition_format != 'Парные соревнования' ? (
                    <View
                      style={[
                        styles.tableColHeader,
                        {
                          width: '9%',
                          backgroundColor: color(item.team?.zona),
                        },
                      ]}
                    >
                      <Text style={styles.tableTextBold}>
                        {isBlank == false ? item.team?.zona : ''}
                      </Text>
                    </View>
                  ) : (
                    <></>
                  )}
                  <View
                    style={[
                      styles.tableColHeader,
                      {
                        width:
                          tournament.competition_format !==
                          'Парные соревнования'
                            ? '9%'
                            : '14%',
                        backgroundColor:
                          tournament.count_cups > 1
                            ? colorsector[item.team?.sector]
                            : '#FFFFFF',
                        // item.zona === 'А'
                        //   ? '#FF2C32' // Красный
                        //   : item.zona === 'Б'
                        //     ? '#139FEC' // Синий
                        //     : item.zona === 'В'
                        //       ? '#FFFB14' // Желтый
                        //       : '#FFFFFF', // Белый (по умолчанию)
                      },
                    ]}
                  >
                    {/* <View
                    style={[
                      styles.tableColHeader,
                      {
                        width:
                          tournament.competition_format !==
                          'Парные соревнования'
                            ? '9%'
                            : '14%',
                        backgroundColor:
                          item.team?.zona === 'А'
                            ? '#FFFFFF' // Красный FF2C32
                            : item.team?.zona === 'Б'
                              ? '#FFFFFF' // Синий 139FEC
                              : item.team?.zona === 'В'
                                ? '#FFFFFF' // Желтый FFFB14
                                : '#FFFFFF', // Белый (по умолчанию)
                      },
                    ]}
                  > */}
                    <Text style={styles.tableTextBold}>
                      {!isBlank && item.team?.sector}
                    </Text>
                  </View>
                </View>
              </View>
            )
        })}
        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
        </View>
        {/* Логотипы партнеров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

const ProtocolComDraw = ({ isBlank }) => {
  const [stage, setStage] = useState(null)
  const [tournament, setTournament] = useState(null)
  const [allLogos, setAllLogos] = useState([])
  const [administrator, setAdministrator] = useState([])
  const [pdfUrl, setPdfUrl] = useState(null)
  const { id } = useParams()
  const [isBlankk, setisBlank] = useState(isBlank)

  const fetchData = async () => {
    const resultsS = await getData('teams', 'id', id)
    if (resultsS.length > 0) {
      const { key, value } = resultsS[0]
      const teamsArray = Object.values(value)
      const filteredTeams = teamsArray.filter((teamEntry) => {
        const isValidTeam =
          teamEntry !== null &&
          typeof teamEntry === 'object' &&
          teamEntry.team?.status === 'Заявка одобрена' &&
          teamEntry.team?.status_location === 1
        return isValidTeam
      })
      setStage(filteredTeams || [])
    }

    const resultsT = await getData('tournaments', 'id', id)
    if (resultsT.length > 0) {
      const { key, value } = resultsT[0]
      setTournament(value)
      const logosArray = Object.values(value.sponsor)
      setAllLogos(logosArray)
      const logosadministrator = Object.values(value.administrator)
      setAdministrator(logosadministrator)
    }
  }

  const handleGenerateAndDownload = async (isPost) => {
    var iscom = isPost == 1 ? false : true

    if (isPost == 1) {
      // eslint-disable-next-line no-restricted-globals
      iscom = confirm(
        'Проверьте сначала все данные нажав кнопку сохранить. После публикации протокол сразу опубликуется в соц.сетях'
      )
    }
    if (iscom) {
      console.log('handleGenerateAndDownload')
      await fetchData()

      if (!stage || !tournament) return

      // Создаем PDF
      const pdfDoc = (
        <TournamentProtocolDrawPDF
          allLogo={allLogos}
          mainLogo={getLogoUrl(tournament?.logocup)}
          data={stage}
          isBlank={isBlankk}
          administrator={administrator}
          tournament={tournament}
          date={dateNowProtocol(new Date())}
        />
      )

      // Генерируем blob
      const blob = await pdf(pdfDoc).toBlob()

      // Создаем URL для скачивания
      const url = URL.createObjectURL(blob)

      // Создаем временную ссылку для скачивания
      const a = document.createElement('a')
      a.href = url
      a.download = `протокол_жеребъёвки_${dateNowProtocol(new Date())}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

      // Отправляем на сервер
      await uploadPdfToServer(blob, isPost)
    }
  }

  const uploadPdfToServer = async (blob, isPost) => {
    try {
      const formData = new FormData()
      formData.append(
        'pdf',
        blob,
        `протокол_жеребъёвки_${dateNowProtocol(new Date())}.pdf`
      )
      formData.append('id', id)
      formData.append('isPost', isPost)

      formData.append('type', 'draw')
      const response = await fetch(
        'https://www.admin-protocarp.ru/php/uploads/upload.php',
        {
          method: 'POST',
          body: formData,
        }
      )

      if (response.ok) {
        const result = await response.json()
        console.log(result)
        console.log(id)
        await deleteData('protocols', id)
        await addPushData('protocols', id, {
          ...result.data.items,
        })
        setPdfUrl(result.fileUrl)
      } else {
        console.error('Ошибка загрузки файла')
      }
    } catch (error) {
      console.error('Ошибка:', error)
    }
  }

  return (
    <div>
      <Button
        variant="contained"
        size="small"
        onClick={() => handleGenerateAndDownload(3)}
        sx={{ mt: 1 }}
      >
        Скачать
      </Button>
      {isBlankk == false ? (
        <Button
          variant="contained"
          size="small"
          color="success"
          onClick={() => handleGenerateAndDownload(1)}
          sx={{ mt: 1, ml: 1 }}
        >
          Опубликовать
        </Button>
      ) : (
        <></>
      )}

      {/* <button
        onClick={handleGenerateAndDownload}
        style={{
          padding: '10px 20px',
          backgroundColor: '#4c7aaf',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        Протокол ЖЕРЕБЬЁВКИ
      </button> */}

      {pdfUrl && (
        <div style={{ marginTop: '20px' }}>
          <Typography variant="body2" color="text.secondary">
            Протокол:
          </Typography>
          <iframe
            src={pdfUrl}
            width="120"
            height="160"
            style={{ border: '1px solid #ccc' }}
            title="Протокол жеребьёвки"
          />
          <p>
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
              <Typography variant="body2" color="text.secondary">
                Открыть в новой вкладке
              </Typography>
            </a>
          </p>
        </div>
      )}
    </div>
  )
}

export default ProtocolComDraw
